export const stringValueIsEmpty = (value: string) => value === "";
